module.exports = __webpack_public_path__ + "static/media/login-background.6492390b.png";